
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { UserTeamModel } from './Identity.Api.Models.UserTeam';
import { Model, ModelProperty } from 'models/Model';


export class UserModel extends Model<UserModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'user.property.id', isHidden: true },
		{ name: 'adIdentifier', type: 'guid', languageString: 'user.property.adIdentifier' },
		{ name: 'username', type: 'string', languageString: 'user.property.username' },
		{ name: 'name', type: 'string', languageString: 'user.property.name' },
		{ name: 'email', type: 'string', languageString: 'user.property.email' },
		{ name: 'internalPhone', type: 'string', languageString: 'user.property.internalPhone' },
		{ name: 'created', type: 'Date', languageString: 'user.property.created', isHidden: true },
		{ name: 'deleted', type: 'Date', languageString: 'user.property.deleted', isHidden: true },
		{ name: 'secretKey', type: 'string', languageString: 'user.property.secretKey' },
		{ name: 'defaultSalesTeamId', type: 'guid', languageString: 'user.property.defaultSalesTeamId' },
		{ name: 'admin', type: 'boolean', languageString: 'user.property.admin' },
		{ name: 'userTeams', type: 'UserTeamModel[]', languageString: 'user.property.userTeams', isHidden: true, isArray: true, isObject: true, new: () => { return new UserTeamModel }, properties: () => { return UserTeamModel.classProperties } },
		{ name: 'receiveNotificationsAsEmail', type: 'boolean', languageString: 'user.property.receiveNotificationsAsEmail' },
		{ name: 'settingsJson', type: 'string', languageString: 'user.property.settingsJson' },
		{ name: 'settings', type: 'UserSettingsModel', languageString: 'user.property.settings', isHidden: true, isObject: true, new: () => { return new UserSettingsModel }, properties: () => { return UserSettingsModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public adIdentifier?: string;
	public username: string;
	public name: string;
	public email: string;
	public internalPhone: string;
	public created?: Date;
	public deleted?: Date;
	public secretKey: string;
	public defaultSalesTeamId?: string;
	public admin: boolean;
	public userTeams: UserTeamModel[];
	public receiveNotificationsAsEmail: boolean;
	public settingsJson?: string;
	public settings?: UserSettingsModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.adIdentifier = undefined;
		this.username = '';
		this.name = '';
		this.email = '';
		this.internalPhone = '';
		this.created = undefined;
		this.deleted = undefined;
		this.secretKey = '';
		this.defaultSalesTeamId = undefined;
		this.admin = false;
		this.userTeams = [];
		this.receiveNotificationsAsEmail = false;
		this.settingsJson = undefined;
		this.settings = undefined;
		
	}
	getProperties(){
		return UserModel.classProperties;
	}
}
export class UserSettingsModel extends Model<UserSettingsModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'dashboardElementSettings', type: 'UserDashboardElementSettingModel[]', languageString: 'userSettings.property.dashboardElementSettings', isHidden: true, isArray: true, isObject: true, new: () => { return new UserDashboardElementSettingModel }, properties: () => { return UserDashboardElementSettingModel.classProperties } }
	];
	[key: string]: any;
	
	public dashboardElementSettings: UserDashboardElementSettingModel[];
    
	constructor(){
		super();
		this.dashboardElementSettings = [];
		
	}
	getProperties(){
		return UserSettingsModel.classProperties;
	}
}
export class UserDashboardElementSettingModel extends Model<UserDashboardElementSettingModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'dashboardElementId', type: 'guid', languageString: 'userDashboardElementSetting.property.dashboardElementId' },
		{ name: 'isExcluded', type: 'boolean', languageString: 'userDashboardElementSetting.property.isExcluded' },
		{ name: 'sortOrder', type: 'number', languageString: 'userDashboardElementSetting.property.sortOrder' }
	];
	[key: string]: any;
	
	public dashboardElementId?: string;
	public isExcluded: boolean;
	public sortOrder?: number;
    
	constructor(){
		super();
		this.dashboardElementId = undefined;
		this.isExcluded = false;
		this.sortOrder = undefined;
		
	}
	getProperties(){
		return UserDashboardElementSettingModel.classProperties;
	}
}

